// extracted by mini-css-extract-plugin
export var filterIncDec = "_59-0";
export var leftBorder = "_59-1";
export var rightBorder = "_59-2";
export var stringInput = "_59-3";